// @ts-nocheck
import { FC, useEffect } from 'react';
import { useMutation } from 'react-query';
import { MenuComponent } from '../../../../../../_dashboard/assets/ts/components';
import { KTSVG } from '../../../../../../_dashboard/helpers';
import { useQueryResponse } from '../../core/QueryResponseProvider';
import dataAxios from '../../../../../modules/auth/core/dataAxios';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';

const API_URL = process.env.REACT_APP_API_URL || '';

type Props = {
  email: string;
  isSubscribed: boolean;
};

const NewsletterActionsCell: FC<Props> = ({ email, isSubscribed }) => {
  const intl = useIntl();
  const { refetchData } = useQueryResponse();

  useEffect(() => {
    MenuComponent.reinitialization();
  }, []);

  const unsubscribeItem = useMutation(
    () => dataAxios.patch(`${API_URL}/newsletter-emails/unsubscribe/${encodeURIComponent(email)}`),
    {
      onSuccess: () => {
        toast.success(
          intl.formatMessage({ id: 'NEWSLETTER.UNSUBSCRIBE_SUCCESS' }),
          { position: 'top-right', autoClose: 4000 }
        );
        refetchData();
      },
      onError: () => {
        toast.error(
          intl.formatMessage({ id: 'NEWSLETTER.UNSUBSCRIBE_ERROR' }),
          { position: 'top-right', autoClose: 4000 }
        );
      },
    }
  );

  if (!isSubscribed) {
    return <span className='text-muted'>—</span>;
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTSVG path='/media/icons/duotune/arrows/Threedots.svg' className='svg-icon-5 m-0' />
      </a>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-1'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            onClick={async () => await unsubscribeItem.mutateAsync()}
          >
            {intl.formatMessage({ id: 'NEWSLETTER.UNSUBSCRIBE' })}
          </a>
        </div>
      </div>
    </>
  );
};

export { NewsletterActionsCell };
